import { useState } from "react";
import { getAuth, sendEmailVerification } from "firebase/auth";
import "./EmailVerificationBanner.css";

const EmailVerificationBanner = ({ userEmail, onRefresh }) => {
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const handleResend = async () => {
    const user = getAuth().currentUser;
    if (!user) return;

    setSending(true);
    setMessage("");

    try {
      await sendEmailVerification(user);
      setMessage("Verification email sent. Check your inbox.");
    } catch (err) {
      setMessage(err.message || "Could not send verification email.");
    } finally {
      setSending(false);
    }
  };

  const handleRefresh = async () => {
    setSending(true);
    setMessage("");

    try {
      const verified = await onRefresh();
      if (verified) {
        setMessage("Email verified. You can use treasury features now.");
      } else {
        setMessage("Email not verified yet. Check your inbox and try again.");
      }
    } catch (err) {
      setMessage(err.message || "Could not refresh verification status.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="email-verification-banner" role="alert">
      <p>
        Verify your email{userEmail ? ` (${userEmail})` : ""} before using treasury
        features.
      </p>
      <div className="email-verification-banner__actions">
        <button
          type="button"
          className="email-verification-banner__btn"
          onClick={handleResend}
          disabled={sending}
        >
          {sending ? "Sending…" : "Resend verification email"}
        </button>
        <button
          type="button"
          className="email-verification-banner__btn"
          onClick={handleRefresh}
          disabled={sending}
        >
          I&apos;ve verified my email
        </button>
      </div>
      {message && <p className="email-verification-banner__message">{message}</p>}
    </div>
  );
};

export default EmailVerificationBanner;
